export const rootElementId = 'verificationUpsell-container';

export const translation = {
  common: [],
  feature: 'Feature.VerificationUpsell'
};
